import { Divider } from "@mui/material";
import React from "react";
import { clx } from "../../../utils/Helpers";
import PropTypes from "prop-types";

const UIActionModalDivider = ({ className, ...props }) => (
  <Divider className={clx("ui-action-modal__divider", className)} {...props} />
);

export default UIActionModalDivider;

UIActionModalDivider.propTypes = {
  className: PropTypes.string,
};

UIActionModalDivider.defaultProps = {
  className: undefined,
};
